export default "__VITE_ASSET__BHmFOIWA__"